import BookFreeClassBtn from '@components/common/book-free-class-btn'
import { FastlyImage } from '@components/common/image'

type Props = {
  urlQuery?: string
}

const TakeAPeek = ({ urlQuery }: Props) => {
  return (
    <section className="py-12 lg:py-16 px-5">
      <div className="container mx-auto flex flex-col">
        <div className="text-center mb-10 mx-auto">
          <h2 className="text-2xl lg:text-4xl font-600 leading-tight mb-4 text-grey max-w-4xl">
            Take a peek inside our Math lessons
          </h2>
        </div>
        <div className="mx-auto flex flex-wrap lg:flex-no-wrap items-center justify-center gap-4">
          <div>
            <FastlyImage
              src="/images/courses/math/class-schedule.png"
              alt="Math Class Preview"
              width={576}
              height={372}
            />
          </div>
          <div>
            <FastlyImage
              src="/images/courses/math/student-learning.png"
              alt="Math Class Preview"
              width={554}
              height={374}
            />
          </div>
        </div>
        <div className="flex justify-center mt-8">
          <BookFreeClassBtn query={urlQuery} />
        </div>
      </div>
    </section>
  )
}

export default TakeAPeek
